export const GET_COMBO_CHDT = 'GET_COMBO_CHDT';
export const GET_COMBO_CHDT_SUCCESS = 'GET_COMBO_CHDT_SUCCESS';
export const GET_COMBO_CHDT_FAILURE = 'GET_COMBO_CHDT_FAILURE';
